import React from 'react';
import './style.css';

const TeamPage = () => {
  // Données d'exemple pour l'équipe - à remplacer par vos données réelles

  return (
    <div className="team-page">
      <div className="team-header">
        <h1>Our Team</h1>
        <p className="team-intro">
          Discover the talents that make our company a trusted partner for your IT projects.
          Our team combines technical expertise, strategic vision, and a passion for innovation.
        </p>
      </div>

      <div className="team-values">
        <h2>Our Values</h2>
        <div className="values-container">
          <div className="value-card">
            <div className="value-icon">🚀</div>
            <h3>Innovation</h3>
            <p>We constantly push technological boundaries to deliver cutting-edge solutions.</p>
          </div>
          <div className="value-card">
            <div className="value-icon">🤝</div>
            <h3>Collaboration</h3>
            <p>We believe in the power of teamwork and close collaboration with our clients.</p>
          </div>
          <div className="value-card">
            <div className="value-icon">💡</div>
            <h3>Excellence</h3>
            <p>We are committed to delivering the highest quality work in all our projects.</p>
          </div>
        </div>
      </div>

      <div className="join-team">
        <h2>Join Our Team</h2>
        <p>
          Are you passionate about technology and want to join a dynamic and innovative team?
          Check our job openings or send us a spontaneous application.
        </p>
        <button className="cta-button">View openings</button>
      </div>
    </div>
  );
};

export default TeamPage;